import React from 'react'
import Box from '@material-ui/core/Box'
import Paper from '@material-ui/core/Paper'
import Button from '@material-ui/core/Button'
import CheckCircleRoundedIcon from '@material-ui/icons/CheckCircleRounded'
import { makeStyles } from '@material-ui/core/styles'
import { useSelector } from 'react-redux'

const useStyles = makeStyles((theme) => ({
  icon: {
    width: 65,
    height: 65,
    color: 'lightgreen',
    marginTop: 60,
    marginBottom: 24,
  },
}))

function Success(props) {
  const classes = useStyles()
  const slug = useSelector((state) => state.create_order.slug)
  return (
    <Box component={Paper} elevation={0} mt={2} pb={8} textAlign="center">
      <CheckCircleRoundedIcon fontSize="large" className={classes.icon} />
      <Box fontSize="20px" mb={1}>
        Order Successfully
      </Box>
      <Box fontSize="16px" mb={5}>
        Order Sharmble Pharmacy, Order no: #{slug} are create complete.
      </Box>
      <Button variant="contained" color="secondary" disableElevation onClick={() => props.setStep(1)}>
        CREATE NEW ORDER
      </Button>
    </Box>
  )
}

export default Success
